import { createLazyReactDirective } from '../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./Activity')).Activity,
  'activity',
  {
    entityId: '=?',
    entityType: '@?',
    lead: '=?',
    onSaveLead: '&',
  },
);
